import React, { Component, Fragment } from 'react';
import { Card, BreadCrumb, Confirm, Modal } from '../../components';
import { Translate } from '../../contexts/Language';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Service } from '../../services';
import { Config } from '../../config';
import Select from 'react-select';
import { ErrorMessage, Validator } from '../../components/Validator';

export class PageRole extends Component {
    constructor(props) {
        super(props)

        this.Refs = React.createRef();

        this.state = {
            dataTable: {
                columns: DataTableColumns.transferOptionsRoles,
                rows: []
            },
            formData: {
                login: "",
                edit: false,
                transferType: []
            },
            transferTypeOption: [],
            validation: {
                error: false,
                message: ""
            }
        }

        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);

        this.typeOptions = [
        { value: 'W', label: <span className="text-danger">Withdrawal Disable</span> },
        { value: 'D', label: <span className="text-danger">Deposit Disable</span> },
        { value: 'I', label: <span className="text-danger">Internal Transfer Disable</span> },
        { value: 'WA', label: <span className="text-success">Withdrawal Alert Enable</span> },
        { value: 'DA', label: <span className="text-success">Deposit Alert Enable</span> }];

    }
    componentDidMount() {

        this.onDataTable();

    }
    onDataTable() {
        Config.utilities.loadingFetch();

        Service.TransferOptions.Roles().then(response => {

            if (response) {

                let dataTable = this.state.dataTable;

                dataTable.rows = response;

                this.setState({
                    dataTable: dataTable
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    onFormChange(e, key) {

        let formData = this.state.formData;

        formData[key] = e.target.value;

        this.setState({
            formData
        });

    }
    onDelete(login) {

        Confirm({
            title: "Are you sure?",
            type: { warning: true },
            description: "The page role will be deleted.",
            onConfirm: () => {

                Config.utilities.loadingFetch();

                Service.TransferOptions.RoleDelete(login).then(response => {


                    Config.utilities.loadingFetch();

                    if (response) {
                        this.onDataTable();
                    }

                });

            },
            onCancel: () => {

            }
        });

    }
    onEdit(login) {

        Config.utilities.loadingFetch();

        this.setState({ modal: true });

        Service.TransferOptions.RoleEdit(login).then(response => {

            if (response) {

                let formData = this.state.formData;

                formData.login = response.login;
                formData.edit = true;

                let transferTypeOption = [];

                if (response.transferType.length > 0) {
                    transferTypeOption = this.typeOptions.filter(item => response.transferType.includes(item.value));
                }

                this.setState({
                    formData,
                    transferTypeOption
                });
            }

            Config.utilities.loadingFetch();
        });

    }
    onNew() {

        let formData = this.state.formData;

        formData.login = "";
        formData.edit = false;
        formData.transferType = [];

        this.setState({
            formData,
            transferTypeOption: []
        }, () => {
            this.setState({ modal: true });
        });

    }
    onSave() {

        let formData = this.state.formData;

        formData.transferType = this.state.transferTypeOption.map(item => item.value);

        if (this.isValid(formData)) {

            Config.utilities.loadingFetch();

            Service.TransferOptions.RoleSave(formData).then(response => {

                if (response.error) {

                    this.setState({
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                }
                else {
                    this.setState({
                        formData: {
                            login: "",
                            edit: false,
                            transferType: []
                        },
                        transferTypeOption: [],
                        modal: false
                    });

                    this.onDataTable();
                }

                Config.utilities.loadingFetch();
            });

        }
    }
    isValid(data) {

        let error = Validator.Valid(data, this.Refs);

        this.setState({
            validation: error
        });

        return !error.error;
    }
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate("Page Role")} Name={Translate("Page Role")} />
                <Modal Title={Translate("Edit Page Role")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                    <div className="row mt-1 mb-1">
                        <p className="text-muted mb-2 ml-1 col-md-12 font-12">Role Information</p>
                        <div className="col-md-12">
                            <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                <ErrorMessage Validation={this.state.validation} />
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="login" className="col-sm-4 col-form-label">Login</label>
                                    <div className="col-sm-8">
                                        <input className="form-control" type="number" id="login" name="login" value={this.state.formData.login} onChange={(e) => this.onFormChange(e, "login")} />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="transferType" className="col-sm-4 col-form-label">Transfer Type</label>
                                    <div className="col-sm-8">
                                        <Select
                                            id="transferType"
                                            value={this.state.transferTypeOption}
                                            onChange={(transferTypeOption) => this.setState({ transferTypeOption })}
                                            options={this.typeOptions}
                                            isMulti={true}
                                            name="transferType"
                                        />
                                    </div>
                                </div>
                                <div className="form-group row ml-1 mr-1">
                                    <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                    <div className="col-sm-8">
                                        <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Modal>
                <Card Title="Transfer Page Role" Description="Customer panel transfer options page role.">
                    <div className="row">
                        <div className="col-md-12">
                            <button type="button" className="btn btn-info position-absolute add-new-button tabless" onClick={(e) => this.onNew()}><i className="fas fa-plus"></i> Add New Page Role</button>
                            {this.state.dataTable.rows.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>No record!</strong> {Translate('No records found for the filter.')} </em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={this.state.dataTable.columns(this.onDelete, this.onEdit)}
                                    data={this.state.dataTable.rows}
                                    defaultSortField="login"
                                    pagination
                                    highlightOnHover />)}
                        </div>
                    </div>
                </Card>
            </Fragment>
        )
    }
}